import React, { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import LanguageSwitcher from '../LanguageSwitcher/LanguageSwitcher';
import './Header.css';
import logo from '../../assets/images/logo.png';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [activeDropdown, setActiveDropdown] = useState(null);
  const menuRef = useRef(null);

  const toggleMenu = () => {
    const newMenuState = !isMenuOpen;
    setIsMenuOpen(newMenuState);
    setActiveDropdown(null);
    
    // Only reset scroll when opening the menu from closed state
    if (newMenuState && window.innerWidth < 992) {
      setTimeout(() => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
        const navContent = document.getElementById('nav-content');
        if (navContent) {
          navContent.scrollTop = 0;
        }
      }, 100);
    }
  };

  const toggleDropdown = (dropdownName, e) => {
    e.preventDefault();
    if (activeDropdown === dropdownName) {
      setActiveDropdown(null);
    } else {
      setActiveDropdown(dropdownName);
      
      // When opening any dropdown on mobile, make sure it's visible
      if (window.innerWidth < 992) {
        setTimeout(() => {
          // Just keep the current scroll position when opening dropdowns
          // This allows users to access items both above and below
        }, 100);
      }
    }
  };

  // Close menu when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setIsMenuOpen(false);
        setActiveDropdown(null);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);
  
  // Add special handling for mobile menu
  useEffect(() => {
    // Fix body scroll when menu is open
    if (isMenuOpen && window.innerWidth < 992) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    
    return () => {
      document.body.style.overflow = '';
    };
  }, [isMenuOpen]);

  // Close menu when navigating
  const handleNavigation = () => {
    setIsMenuOpen(false);
    setActiveDropdown(null);
  };

  return (
    <header className="header">
      <div className="container">
        <nav className="navbar navbar-expand-lg" ref={menuRef}>
          <div className="navbar-header">
            <h2 className="nav-brand">
              <Link className="navbar-brand" to="/" onClick={handleNavigation}>
                <img src={logo} alt="Teknoma Logo" style={{ height: '60px' }} />
              </Link>
            </h2>
            <button 
              className="navbar-toggler" 
              type="button" 
              onClick={toggleMenu}
              aria-controls="nav-content" 
              aria-expanded={isMenuOpen ? "true" : "false"} 
              aria-label="Toggle navigation"
            >
              <span className="navbar-toggler-icon"></span>
            </button>
          </div>
          <div className={`main-menu collapse navbar-collapse ${isMenuOpen ? 'show' : ''}`} id="nav-content">
            <ul className="navbar-nav">
              <li className="menu-item nav-item">
                <Link to="/" onClick={handleNavigation}>
                  <i className="fa fa-home fa-lg"></i>
                </Link>
              </li>
              <li className="menu-item nav-item">
                <Link to="/hakkimizda" onClick={handleNavigation}>Hakkımızda</Link>
              </li>
              <li className="menu-item dropdown nav-item" id="urunler-dropdown">
                <a 
                  className={`nav-link dropdown-toggle ${activeDropdown === 'urunler' ? 'active' : ''}`} 
                  href="#urunler" 
                  onClick={(e) => toggleDropdown('urunler', e)}
                >
                  Ürünler
                </a>
                <ul className={`dropdown-menu depth_0 ${activeDropdown === 'urunler' ? 'show' : ''}`}>
                  <li className="menu-item dropdown-item" style={{paddingTop: '5px'}}>
                    <Link to="/indium-kalay-oksit-ito-kaplamalar" onClick={handleNavigation} style={{paddingTop: '10px'}}>ITO Kaplamalar</Link>
                  </li>
                  <li className="menu-item dropdown-item">
                    <Link to="/molibdenyum-kaplamalar" onClick={handleNavigation}>Molibdenyum Kaplamalar</Link>
                  </li>
                  <li className="menu-item dropdown-item">
                    <Link to="/flor-kalay-oksit-fto-kaplamalar" onClick={handleNavigation}>FTO Kaplamalar</Link>
                  </li>
                  <li className="menu-item dropdown-item">
                    <Link to="/altin-kaplamalar" onClick={handleNavigation}>Au (Altın) Kaplı Camlar</Link>
                  </li>
                  <li className="menu-item dropdown-item">
                    <Link to="/indium-kalay-oksit-ito-pet-kaplamalar" onClick={handleNavigation}>ITO kaplamalı PET ve PC</Link>
                  </li>
                  <li className="menu-item dropdown-item">
                    <Link to="/isiticili-pencere" onClick={handleNavigation}>Isıtıcılı Pencere</Link>
                  </li>
                  <li className="menu-item dropdown-item">
                    <Link to="/gumus-kapli-lifler" onClick={handleNavigation}>Gümüş Kaplı Lifler</Link>
                  </li>
                  <li className="menu-item dropdown-item">
                    <Link to="/vakum-sistemleri" onClick={handleNavigation}>Vakum Sistemleri</Link>
                  </li>
                  <li className="menu-item dropdown-item">
                    <Link to="/miknatis-sactirma-kaynaklari" onClick={handleNavigation}>Mıknatıssal Saçtırma Kaynakları</Link>
                  </li>
                </ul>
              </li>
              <li className="menu-item dropdown nav-item" id="hizmetler-dropdown">
                <a 
                  className={`nav-link dropdown-toggle ${activeDropdown === 'hizmetler' ? 'active' : ''}`} 
                  href="#hizmetler" 
                  onClick={(e) => toggleDropdown('hizmetler', e)}
                >
                  Hizmetler
                </a>
                <ul className={`dropdown-menu depth_0 ${activeDropdown === 'hizmetler' ? 'show' : ''}`}>
                  <li className="menu-item dropdown-item">
                    <Link to="/malzeme-test-ve-analizleri" onClick={handleNavigation}>Malzeme Test ve Analizleri</Link>
                  </li>
                  <li className="menu-item dropdown-item">
                    <Link to="/yuzey-kaplamalar" onClick={handleNavigation}>Yüzey Kaplamalar</Link>
                  </li>
                  <li className="menu-item dropdown-item">
                    <Link to="/danismanlik" onClick={handleNavigation}>Danışmanlık</Link>
                  </li>
                  <li className="menu-item dropdown-item">
                    <Link to="/egitim" onClick={handleNavigation}>Eğitim</Link>
                  </li>
                </ul>
              </li>
              <li className="menu-item nav-item">
                <Link to="/projeler" onClick={handleNavigation}>Projeler</Link>
              </li>
              <li className="menu-item dropdown nav-item" id="uygulamalar-dropdown">
                <a 
                  className={`nav-link dropdown-toggle ${activeDropdown === 'uygulamalar' ? 'active' : ''}`} 
                  href="#uygulamalar" 
                  onClick={(e) => toggleDropdown('uygulamalar', e)}
                >
                  Uygulamalar
                </a>
                <ul className={`dropdown-menu depth_0 ${activeDropdown === 'uygulamalar' ? 'show' : ''}`}>
                  <li className="menu-item dropdown-item">
                    <Link to="/sivi-kristal-gostergeler" onClick={handleNavigation}>Sıvı Kristal Göstergeler</Link>
                  </li>
                  <li className="menu-item dropdown-item">
                    <Link to="/organik-isin-yayan-diotlar" onClick={handleNavigation}>Organik Işın Yayan Diotlar</Link>
                  </li>
                  <li className="menu-item dropdown-item">
                    <Link to="/gunes-pilleri" onClick={handleNavigation}>Güneş Hücreleri</Link>
                  </li>
                  <li className="menu-item dropdown-item">
                    <Link to="/akilli-camlar" onClick={handleNavigation}>Akıllı Camlar</Link>
                  </li>
                  <li className="menu-item dropdown-item">
                    <Link to="#radar" onClick={handleNavigation}>Radar Soğurma</Link>
                  </li>
                </ul>
              </li>
              <li className="menu-item nav-item">
                <Link to="/referanslar" onClick={handleNavigation}>Referanslar</Link>
              </li>
              <li className="menu-item nav-item">
                <Link to="/iletisim" onClick={handleNavigation}>İletişim</Link>
              </li>
              <LanguageSwitcher />
            </ul>
          </div>
        </nav>
      </div>
    </header>
  );
};

export default Header;